import { useTranslation } from "react-i18next";
import { FlowBoxButton, FlowBox, FlowBoxTitle, Paragraph } from "melco-ui";
import {
  InputField,
  DisplayFormErrors,
  VerticalForm,
} from "melco-shared-logic";
import { FormikProps } from "formik";

import { LoginFormValueType } from "./LoginForm";

export const DisplayLoginForm: React.FC<FormikProps<LoginFormValueType>> = ({
  isSubmitting,
}) => {
  const { t } = useTranslation();

  return (
    <VerticalForm>
      <DisplayFormErrors />

      <FlowBox>
        <FlowBoxTitle>{t("loginpage.password.title")}</FlowBoxTitle>

        <Paragraph>{t("loginpage.password.paragraph")}</Paragraph>

        <InputField
          name="password"
          size="large"
          placeholder={t("loginpage.password.placeholder")}
          type="password"
          autoComplete="current-password"
        // info={t("loginpage.password.info")}
        //  label={t("loginpage.password.label")}
        />

        <FlowBoxButton
          loading={isSubmitting}
          disabled={isSubmitting}
          htmlType="submit"
        >
          {t("loginpage.submit")}
        </FlowBoxButton>
      </FlowBox>
    </VerticalForm>
  );
};
